import axios from 'axios';
import { API_URL } from '../config/constants';
const rota = 'site';

const sendContact = async body => {
    const res = await axios.post(`${API_URL}${rota}/send-contact`, body);
    return res.data;
}

const subscribeEmail = async body => {
    const res = await axios.post(`${API_URL}${rota}/subscribe`, body);
    return res.data;
}

export default { sendContact, subscribeEmail };